import { createContext } from "react";

const SideMenuCommonFilterDefault = createContext({});

export default SideMenuCommonFilterDefault;
